import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { absUrl } from "../blocks/media";
import { renderInline } from "../blocks/renderInline";

export const INTRO_DEFAULTS = {
  eyebrow: "What is THE WALL", title: "A free community platform by Artists 4 Life in the Sound.",
  body: "Local music is the gift. Local businesses are the map. Local orgs are the safety net. THE WALL ties them together so a night out in the South Sound is easier to find, cheaper to enjoy — and safer. **This music saves lives.**",
  link1_label: "About THE WALL →", link1_url: "/about", link2_label: "Our origins →", link2_url: "/our-origins",
  image: "https://customer-assets.emergentagent.com/job_211279cf-e69f-4285-b28c-6209ba7e3f92/artifacts/dlad1gog_dolly%20the%20llama%20this%20music%20saves%20lives.png",
  steps: [
    { title: "Artists give music", body: "Local bands add tracks to THE WALL. Their music becomes the free gift that opens every door." },
    { title: "Businesses give Gems", body: "Deals, specials and gifts — mapped for the Holiday HOPE Hop and carried in THE HOARD." },
    { title: "Everyone gives & lets live", body: "Neighbors show up, orgs get seen, and every room learns the North Star drink-spiking signs." },
  ],
  ctas: [
    { icon: "Mic2", label: "Bands: add your music", url: "/for-bands", color: "#1A1A1A", text_color: "#F2CC8F" },
    { icon: "Gem", label: "Businesses: add a Gem", url: "/for-businesses", color: "#2E5C55", text_color: "#FFFFFF" },
    { icon: "CalendarDays", label: "Everyone: calendar & guide", url: "/events", color: "#E76F51", text_color: "#FFFFFF" },
  ],
};
const IDS = ["final-cta-bands", "final-cta-biz", "final-cta-everyone"];

export const HomeIntro = ({ block }) => {
  const cfg = { ...INTRO_DEFAULTS, ...(block?.config || {}) };
  return (
    <section className="bg-[#F9F8F6] py-14 sm:py-20" data-testid="what-is-the-wall-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] items-center">
          <div data-testid="artists-4-life-story">
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#E76F51] flex items-center gap-2"><Icons.Heart className="h-4 w-4" fill="currentColor" /> {cfg.eyebrow}</p>
            <h2 className="mt-2 font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#1A1A1A] leading-tight">{block?.title || cfg.title}</h2>
            <p className="mt-4 text-base sm:text-lg text-[#5C5C5C] leading-relaxed [&_strong]:text-[#1A1A1A]">{renderInline(block?.quip || cfg.body)}</p>
            <div className="mt-5 flex flex-wrap gap-4 text-sm font-bold">
              {cfg.link1_label && <Link to={cfg.link1_url} className="text-[#2E5C55] hover:underline" data-testid="intro-about-link">{cfg.link1_label}</Link>}
              {cfg.link2_label && <Link to={cfg.link2_url} className="text-[#2E5C55] hover:underline" data-testid="intro-origins-link">{cfg.link2_label}</Link>}
            </div>
          </div>
          <div className={`grid gap-6 items-center ${cfg.image ? "sm:grid-cols-[auto_1fr]" : ""}`}>
            {cfg.image && <img src={absUrl(cfg.image)} alt="" className="w-40 sm:w-48 mx-auto rounded-2xl shadow-md" loading="lazy" />}
            <ol className="space-y-3">
              {(cfg.steps || []).map((s, i) => (
                <li key={i} className="flex gap-4 rounded-2xl bg-white border border-[#2E5C55]/15 p-4 shadow-sm" data-testid={`how-it-works-step-${i + 1}`}>
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#2E5C55] text-white font-extrabold">{i + 1}</span>
                  <span><span className="block font-extrabold text-[#1A1A1A]">{s.title}</span><span className="block text-sm text-[#5C5C5C] leading-snug">{s.body}</span></span>
                </li>
              ))}
            </ol>
          </div>
        </div>
        {(cfg.ctas || []).length > 0 && (
          <div className="mt-12 grid gap-3 sm:grid-cols-3" data-testid="final-cta-strip">
            {cfg.ctas.map((c, i) => {
              const Icon = Icons[c.icon] || Icons.ArrowRight;
              return (
                <Link key={i} to={c.url || "/"} className="flex items-center justify-between rounded-2xl px-5 py-4 font-bold shadow-md hover:-translate-y-0.5 active:scale-[0.98] transition-transform" style={{ backgroundColor: c.color || "#2E5C55", color: c.text_color || "#fff" }} data-testid={IDS[i] || `final-cta-${i}`}>
                  <span className="flex items-center gap-2"><Icon className="h-5 w-5" /> {c.label}</span><Icons.ArrowRight className="h-5 w-5" />
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};
